import React from 'react';
import { Tooltip as MuiTooltip, styled } from '@mui/material';
import { TooltipProps } from '@mui/material/Tooltip';

const StyledTooltip = styled(({ className, ...props }: TooltipProps) => (
  <MuiTooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  '& .MuiTooltip-tooltip': {
    background: theme.palette.common.white,
    borderColor: theme.palette.grey[300],
    color: '#767678',
    fontSize: '14px',
    padding: '8px 12px',
    boxShadow: '0px 2px 6px rgba(0, 0, 0, 0.15)',
    maxWidth: 300,
    borderRadius: 4,
    fontWeight: 400,
  },
  '& .MuiTooltip-arrow': {
    color: 'white',
    '&::before': {
      boxShadow: '1px 1px 3px rgba(0, 0, 0, 0.08)',
    },
  },
}));

interface CustomTooltipProps extends Omit<TooltipProps, 'children'> {
  children: React.ReactElement;
}

const CustomTooltip: React.FC<CustomTooltipProps> = ({
  children,
  ...props
}) => {
  return (
    <StyledTooltip arrow placement="top" {...props}>
      {children}
    </StyledTooltip>
  );
};

export default CustomTooltip;
